import { render, staticRenderFns } from "./AutoCheckHighRisk.vue?vue&type=template&id=55b2a1f6&"
import script from "./AutoCheckHighRisk.vue?vue&type=script&lang=js&"
export * from "./AutoCheckHighRisk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports